// extracted by mini-css-extract-plugin
export var active = "_br-2";
export var highlight = "_br-1";
export var highlightLayer = "_br-0";
export var issuePopover = "_br-3";
export var statusIcon = "_br-4";